import { ShieldAlert, Users, CalendarX, Video } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";
import { CtaButton } from "./CtaButton";

const PROBLEMS = [
  {
    icon: ShieldAlert,
    title: "Kontrola Sanepidu",
    text: "Higiena, przechowywanie żywności, dezynfekcja. Brak dokumentacji = kary.",
  },
  {
    icon: Users,
    title: "Kontrola PIP",
    text: "Umowy z pracownikami, ewidencja czasu pracy — zwłaszcza przy zmianowości i sezonowości.",
  },
  {
    icon: CalendarX,
    title: "Rezerwacja bez regulaminu",
    text: "Gość nie przychodzi, a Ty nie masz podstawy, by dochodzić straty.",
  },
  {
    icon: Video,
    title: "Monitoring bez klauzuli RODO",
    text: "Kamery w lokalu bez informacji dla gości i pracowników to naruszenie.",
  },
];

export const ProblemSection = ({ onBuy }) => (
  <section id="problem" data-testid="problem-section" className="bg-cream px-6 py-24 sm:px-10 sm:py-32 lg:px-16">
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <Kicker index="01" label="Problem" />
        <h2 className="mt-6 max-w-2xl font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          Dlaczego to Cię dotyczy
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 sm:gap-6">
        {PROBLEMS.map((p, i) => (
          <Reveal key={p.title} delay={0.08 * i}>
            <article
              data-testid={`problem-card-${i}`}
              className="group relative h-full rounded-3xl border border-sand bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-brick/40 hover:shadow-xl hover:shadow-brick/10 sm:p-9"
            >
              <span className="absolute right-7 top-6 font-display text-2xl italic text-choc/15 sm:right-9">
                {String(i + 1).padStart(2, "0")}.
              </span>
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-brick/10 text-brick transition-colors duration-300 group-hover:bg-brick group-hover:text-white">
                <p.icon className="h-6 w-6" />
              </span>
              <h3 className="mt-6 font-display text-xl font-semibold sm:text-2xl">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-clay sm:text-base">{p.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-12 flex justify-center">
        <CtaButton onBuy={onBuy} testid="problem-cta-button" />
      </Reveal>
    </div>
  </section>
);
